import React from 'react';
import Favourite from 'styles/staticAssets/images/Favourite.svg';
import { getFullImagePath, getFilteredItems } from 'common/utilities/utils';
import ImageComponent from 'atoms/Image';
import heartIcon_active_red from 'styles/staticAssets/images/heartIcon_active_red.svg';
import _get from 'lodash/get';
import { find } from 'lodash';
import {
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { useDispatch } from 'react-redux';

const OrderItemDetailsComponent = props => {
  const { cardInfo, tenantData, orderItemArray, favouriteItems, customerId } = props;
  const { tenantId, currencySymbol, currencyConversionFactor, addHope, carryBag } = tenantData;
  const { id } = cardInfo;
  const itemInfo = orderItemArray.find(order => order.id === id) || {};
  const { foodLines = [] } = itemInfo;
  let filteredItems = getFilteredItems(foodLines, addHope, carryBag);

  const currencyConversion = amount => {
    return(
      (amount / currencyConversionFactor).toFixed(2)
    )
  };

  const dispatch = useDispatch();

  const addRemoveToFavourite = (item, isRemove, food) => {
    const {
      mdmId,
      id,
      name,
      imageName,
      longDescription: description,
      quantity,
      customizable: isCustomized,
      customProperties: additionalProperties,
    } = item;
    if (isRemove) {
      dispatch(
        addItemToUnFavouriteAction({
          customerId,
          tenantId,
          itemId: id,
        }),
      );
    } else {
      dispatch(
        addItemToFavouriteAction(
          {
            customerId,
            tenantId,
          },
          {
            mdmId,
            id,
            name,
            imageName,
            description,
            quantity,
            isCustomized,
            price: food?.unitPrice / currencyConversionFactor,
            additionalProperties,
          },
        ),
      );
    }
  };

  const getDescription = data => {
    const modGroups = _get(data, 'modGrps', []);
    const modifiersDetails = modGroups.map(o => o.modifiers).flat();
    return(
      modifiersDetails.map(item => `${item.quantity}x ${item.name}`).join()
    )
  };

  return (
    <>
      {filteredItems.map(food => {
        const { item } = food;
        const { mdmId, unitPrice } = item;
        const isFavourite = find(favouriteItems, { mdmId });
        return (
          <div className='global-accordian-header-container order-section'>
            <span className='global-accordian-header mobile-order-details-section'>
              <ImageComponent
                className={'order-item-img'}
                defaultPath={getFullImagePath(null, tenantData, true)}
                srcFile={getFullImagePath(item.imageName, tenantData)}
              />
            </span>
            <span className='product-details-section'>
              <span className='product-title'>
                {item.quantity}x {item.name}
              </span>
              <span className='product-desc'>{getDescription(item)}</span>
              <span className='product-price'>
                {currencySymbol}
                {currencyConversion(unitPrice)}
              </span>
            </span>
            <div
              className='global-accordian-right'
              data-testid='favourite-btn'
              onClick={() => addRemoveToFavourite(item, isFavourite, food)}
            >
              <img src={isFavourite ? heartIcon_active_red : Favourite} className='account-icon' alt='Account Icon'/>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default OrderItemDetailsComponent;
